// SPDX-License-Identifier: AGPL-3.0-or-later

export interface WhatsNewEntry {
	id: string;
	date: Date;
	content: string;
}

export const WHATS_NEW_ENTRIES: ReadonlyArray<WhatsNewEntry> = [
	{
		id: '2026-11-01',
		date: new Date('2026-11-01T00:00:00Z'),
		content: `### Yeni

- Sunucudaki takviye satırı yenilendi: her seviye kendi renginde görünüyor.
- Bas-konuş tuşu mikrofonu açıp kapatınca ses çalıyor. Bildirim seslerinden kapatılabilir.

### Düzeltmeler

- Mikrofon hızlı açılıp kapatılınca kendi kendine değişiyordu, düzeltildi.
- Windows'ta kısayollar başka bir tuşla da çalışıyordu: M tuşundaki bas-konuş 2 ile de açılıyordu, düzeltildi.
- Türkçe Q klavyede ö, ç, ", * ve < tuşları kısayol olarak çalışmıyordu, düzeltildi.
- Kısayol düzenlerken sol tık kısayolun yerine kaydediliyordu, düzeltildi.
- 3B odada emoji gönderince karakter yürümüyordu, düzeltildi.
- 3B odada TV'nin önüne gelen karakter görüntünün altında kalıyordu, düzeltildi.
- 3B odada biten oyunun tahtası masada kalıyordu, düzeltildi.
- 3B odada başlamamış masadan kalkınca koltuk boşalmıyordu, düzeltildi.
- Kapatılan 3B oda görüşme ekranından yeniden açılamıyordu, düzeltildi.
- Odaklı yayın düzeni ve küçük pencere denetimleri düzeltildi.
- Plus sayfasında planlar okunamayınca sayfa boş kalıyordu. Artık sebebi ve yeniden dene düğmesi görünüyor.
- Satın alma kapalıysa sebebi artık ödeme penceresinde yazıyor.
- Profil teması uygulama temasından farklıysa açıklama yazısı okunmuyordu, düzeltildi.`,
	},
];

export function hasWhatsNewEntries(): boolean {
	return WHATS_NEW_ENTRIES.length > 0;
}
